import { ReactText } from 'react';
import { IntlFormatters } from 'react-intl';
import moment from 'moment/moment';

import { INVALID_DATE } from 'constants/globals';
import messages from 'components/Range/messages';

type Range = {
  endYear: number | null;
  formatMessage: IntlFormatters['formatMessage'];
  startYear: number | null;
  endMonth?: number | null;
  format?: 'short' | 'onlyYears';
  startMonth?: number | null;
};

export const rangeText = ({
  startYear = null,
  startMonth = null,
  endYear = null,
  endMonth = null,
  format,
  formatMessage,
}: Range) => {
  const monthMsg = (month: number | null): string =>
    month ? formatMessage(messages.month, { month }) : '';
  const present = !endYear;

  let start = `${monthMsg(startMonth)} ${startYear || ''}`.trim();

  let finish = `${monthMsg(endMonth)} ${endYear || ''}`.trim();

  if (format) {
    const currentFormat = format === 'short' ? 'MMM` YY' : 'YYYY';
    const startShortFormat = moment([
      startYear,
      typeof startMonth !== 'number' ? 0 : startMonth - 1,
    ] as Array<ReactText>).format(currentFormat);
    const finishShortFormat = moment([
      endYear,
      typeof endMonth !== 'number' ? 0 : endMonth - 1,
    ] as Array<ReactText>).format(currentFormat);

    start =
      startShortFormat === INVALID_DATE
        ? ''
        : startShortFormat.charAt(0).toUpperCase() + startShortFormat.slice(1);
    finish =
      finishShortFormat === INVALID_DATE
        ? ''
        : finishShortFormat.charAt(0).toUpperCase() + finishShortFormat.slice(1);
  }

  if (start && present) {
    return `${start} — ${formatMessage(messages['present'])}`;
  }

  if (start && finish) {
    return `${start} — ${finish}`;
  }

  if (start) {
    return `${formatMessage(messages['from'])} ${start}`;
  }

  if (finish) {
    return `${formatMessage(messages['until'])} ${finish}`;
  }

  return null;
};
